export default __webpack_public_path__ + "static/media/7.b6a39a73.png";